import { useState } from 'react';

import type { GroupPhoto } from '@lbc/shared';

import { PhotoViewer } from '../photos/PhotoViewer';

export function WrappedPhotoHighlights({ highlights }: { highlights: GroupPhoto[] }) {
  const [selectedPhoto, setSelectedPhoto] = useState<GroupPhoto | null>(null);
  return (
    <>
      <section className="wrapped-panel wrapped-panel--full" aria-labelledby="wrapped-photo-title">
        <div className="section-heading">
          <div>
            <p className="step-label">Die schönsten Momente</p>
            <h3 id="wrapped-photo-title">Gruppenfotos</h3>
          </div>
          <span className="people-count">{highlights.length}</span>
        </div>
        {highlights.length === 0 ? (
          <p className="chart-empty">Noch kein Monats-Highlight vorhanden.</p>
        ) : (
          <div className="wrapped-photo-list">
            {highlights.map((photo) => (
              <button
                className="wrapped-photo-list__item"
                type="button"
                key={photo.id}
                onClick={() => setSelectedPhoto(photo)}
              >
                <span aria-hidden="true">♡</span>
                <span>
                  <strong>{formatPhotoMonth(photo.highlightMonth)}</strong>
                  <small>
                    {photo.photographerName} · {photo.likeCount} Likes
                  </small>
                </span>
              </button>
            ))}
          </div>
        )}
      </section>
      {selectedPhoto !== null ? (
        <PhotoViewer
          key={selectedPhoto.id}
          photo={selectedPhoto}
          onClose={() => setSelectedPhoto(null)}
        />
      ) : null}
    </>
  );
}

function formatPhotoMonth(month: string | null): string {
  if (month === null) return 'Gruppenfoto';
  return new Intl.DateTimeFormat('de-DE', { month: 'long', year: 'numeric' }).format(
    new Date(`${month}-01T12:00:00Z`),
  );
}
